const doc = [({"en":({"js":({"nemoa":({"required_metadata":({"required_metadata_proxy":({"fill_out_missing_fields_to_continue":"Fill out missing fields to continue."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;